/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eaten: NonNullable<unknown>, goal: NonNullable<unknown> }} Portal_Kcal_OfInputs */

const en_portal_kcal_of = /** @type {(inputs: Portal_Kcal_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.eaten} / ${i?.goal} kcal`)
};

const pl_portal_kcal_of = /** @type {(inputs: Portal_Kcal_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.eaten} / ${i?.goal} kcal`)
};

/**
* | output |
* | --- |
* | "{eaten} / {goal} kcal" |
*
* @param {Portal_Kcal_OfInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_kcal_of = /** @type {((inputs: Portal_Kcal_OfInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Kcal_OfInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_kcal_of(inputs)
	return en_portal_kcal_of(inputs)
});